import { PLATFORM_LINKS } from "../constants/links.constant";
import { SpotifyIcon } from "./icons/spotify.component";
import { AppleMusicIcon } from "./icons/apple-music.component";
import { AmazonMusicIcon } from "./icons/amazon-music.component";
import { YouTubeIcon } from "./icons/youtube.component";

const ICON_CLS = "text-primary/30 hover:text-primary transition-colors duration-300";

export function Footer() {
  return (
    <footer className="flex flex-col md:flex-row items-center justify-between gap-4 py-12 px-6 md:px-13 border-t border-border-light">
      <span className="text-xs tracking-[0.2em] uppercase text-primary font-extrabold">
        MOODE.ART
      </span>
      <div className="flex items-center gap-4">
        <a href={PLATFORM_LINKS.spotify.href} target="_blank" rel="noreferrer">
          <SpotifyIcon size={18} className={ICON_CLS} />
        </a>
        <a href={PLATFORM_LINKS.appleMusic.href} target="_blank" rel="noreferrer">
          <AppleMusicIcon size={18} className={ICON_CLS} />
        </a>
        <a href={PLATFORM_LINKS.amazonMusic.href} target="_blank" rel="noreferrer">
          <AmazonMusicIcon size={18} className={ICON_CLS} />
        </a>
        <a href={PLATFORM_LINKS.youtube.href} target="_blank" rel="noreferrer">
          <YouTubeIcon size={18} className={ICON_CLS} />
        </a>
      </div>
      <span className="text-[11px] tracking-widest text-muted">
        © {new Date().getFullYear()} — All rights reserved
      </span>
    </footer>
  );
}
